import localStorage from "localStorage";
import { not, isNil } from "ramda";

export const LOCAL_STORAGE_AUTH_KEY = "authInfo";

export const RECIPIENT_SESSION_KEY = "sessionIsRecipient";

export const CURRENT_MAKE = "currentMake";

export const DATA_VOLUME = "dataVolume";

export const UPDATED_PAGE_KEY = "updated_page_key";

export default {
  hasItem(key) {
    return not(isNil(localStorage.getItem(key)));
  },

  getItem(key) {
    const value = localStorage.getItem(key);
    return typeof value === "undefined" ? null : JSON.parse(value);
  },

  setItem(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  },

  removeItem(key) {
    localStorage.removeItem(key);
  },
};
